import { render, staticRenderFns } from "./product-list-page-wrapper.vue?vue&type=template&id=8837bb86&"
import script from "./product-list-page-wrapper.vue?vue&type=script&lang=js&"
export * from "./product-list-page-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./product-list-page-wrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports